import Vue from 'vue'
import Router from 'vue-router'
import ProgressBar from '~/components/progress-bar.vue'
import cookie from '~/utils/cookie'

// 全局进度条
const bar = Vue.prototype.$bar = new Vue(ProgressBar).$mount()
document.body.appendChild(bar.$el)

// 超级管理员
const SUPER = 'super'
// 老板
const BOSS = 'boss'
// 办公室经理
const MANAGER = 'manager'

Vue.use(Router)

const routes = [
  {
    path: '/404',
    component: () => import('../views/404.vue')
  },
  {
    path: '*',
    redirect: '/404'
  },
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    component: () => import('../views/login')
  },
  {
    // 首页
    path: '/home',
    component: () => import('../views/home'),
    meta: {
      authentication: true,
      rules: [SUPER, BOSS, MANAGER]
    },
    children: [
      {
        // 商品管理
        path: 'products',
        component: () => import('../views/home/products/index.vue'),
        meta: {
          authentication: true,
          rules: [BOSS, MANAGER]
        }
      },
      {
        // 商品详情
        path: 'products/details/:type',
        component: () => import('../views/home/products/details.vue'),
        meta: {
          authentication: true,
          rules: [BOSS, MANAGER]
        }
      },
      {
        // 优惠券管理
        path: 'coupons',
        component: () => import('../views/home/coupons/index.vue'),
        meta: {
          authentication: true,
          rules: [BOSS, MANAGER]
        }
      },
      {
        // 优惠券详情
        path: 'coupons/details/:type',
        component: () => import('../views/home/coupons/details.vue'),
        meta: {
          authentication: true,
          rules: [BOSS, MANAGER]
        }
      },
      {
        // 优惠券明细
        path: 'coupons/items/:id',
        component: () => import('../views/home/coupons/items.vue'),
        meta: {
          authentication: true,
          rules: [BOSS, MANAGER]
        }
      },
      {
        // 优惠券 退款审核
        path: 'coupons/refund',
        component: () => import('../views/home/coupons/refund.vue'),
        meta: {
          authentication: true,
          rules: [BOSS, MANAGER]
        }
      },
      {
        // 品牌管理
        path: 'brands',
        component: () => import('../views/home/brands/index.vue'),
        meta: {
          authentication: true,
          rules: [SUPER]
        }
      },
      {
        // 门店管理
        path: 'shops',
        component: () => import('../views/home/shops/index.vue'),
        meta: {
          authentication: true,
          rules: [BOSS, MANAGER]
        }
      },
      {
        // 门店详情
        path: 'shops/details/:type',
        component: () => import('../views/home/shops/details.vue'),
        meta: {
          authentication: true,
          rules: [BOSS, MANAGER]
        }
      },
      {
        // 店员管理
        path: 'clerks',
        component: () => import('../views/home/clerks/index.vue'),
        meta: {
          authentication: true,
          rules: [BOSS, MANAGER]
        }
      },
      {
        // 店员管理
        path: 'clerks/details/:type',
        component: () => import('../views/home/clerks/details.vue'),
        meta: {
          authentication: true,
          rules: [BOSS, MANAGER]
        }
      },
      {
        // 首页Banner管理
        path: 'banners',
        component: () => import('../views/home/banners/index.vue'),
        meta: {
          authentication: true,
          rules: [SUPER]
        }
      },
      {
        // 摄像头管理
        path: 'camera',
        component: () => import('../views/home/camera/index.vue'),
        meta: {
          authentication: true,
          rules: [SUPER]
        }
      },
      {
        // 摄像头详情
        path: 'camera/details/:type',
        component: () => import('../views/home/camera/details.vue'),
        meta: {
          authentication: true,
          rules: [SUPER]
        }
      },
      {
        // 数据统计
        path: 'statistics',
        component: () => import('../views/home/statistics/index.vue'),
        meta: {
          authentication: true,
          rules: [BOSS, MANAGER]
        }
      },
      {
        // 账号管理
        path: 'account',
        component: () => import('../views/home/account/index.vue'),
        meta: {
          authentication: true,
          rules: [SUPER]
        }
      },
      {
        // 账号管理 添加账号
        path: 'account/add',
        component: () => import('../views/home/account/details.vue'),
        meta: {
          authentication: true,
          rules: [SUPER]
        }
      },
      {
        // 客户查询
        path: 'user',
        component: () => import('../views/home/user/index.vue'),
        meta: {
          authentication: true,
          rules: [SUPER]
        }
      },
      {
        // 门店浏览记录
        path: 'shopHistory',
        component: () => import('../views/home/shopHistory/index.vue'),
        meta: {
          authentication: true,
          rules: [SUPER, BOSS, MANAGER]
        }
      }
    ]
  }
]

const router = new Router({
  mode: 'history',
  routes,
  linkActiveClass: 'link-active',
  scrollBehavior (to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  }
})

router.beforeEach(async (to, from, next) => {
  bar.start()
  // cookie 中没有token 是： undefined "token" (undefined: 返回一个未定义的对象)
  let token = cookie.get('token')
  // localStorage 中没有baseinfo 是：  null "userInfo" (null: 此处不应有值 没有对象)
  // 所以 userInfo.role 会报错
  let userInfoJsonStr = localStorage.getItem('userInfo')
  // 如果需要身份验证
  if (to.meta.authentication) {
    /**
     * 必须登录
     */
    if (token && userInfoJsonStr) {
      let role = JSON.parse(localStorage.getItem('userInfo')).role
      // 符合此页面权限
      if (to.meta.rules.includes(role)) {
        next()
      } else {
        next('/404')
      }
    } else {
      next('/login')
    }
  } else {
    next()
  }
})

router.afterEach((to, from) => {
  bar.finish()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js